import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { api, errMsg } from "../lib/api";

export const UploadButton = ({ onUploaded, onDuplicate }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const st = await api.upload(file);
      toast.success("Kontoauszug hochgeladen – Buchungen werden ausgelesen …");
      onUploaded(st);
    } catch (err) {
      if (err?.response?.status === 409) {
        toast.warning("Duplikat erkannt", { description: errMsg(err), duration: 8000 });
        onDuplicate(err.response.data.existing_statement_id);
      } else {
        toast.error("Upload fehlgeschlagen", { description: errMsg(err) });
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <input ref={ref} type="file" accept="application/pdf,.pdf" className="hidden" onChange={handle} data-testid="upload-file-input" />
      <Button
        data-testid="upload-kontoauszug-btn"
        onClick={() => ref.current?.click()}
        disabled={busy}
        className="h-11 w-full justify-center gap-2 bg-slate-900 text-[15px] font-semibold hover:bg-slate-800"
      >
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
        {busy ? "Wird hochgeladen …" : "Kontoauszug hochladen"}
      </Button>
    </>
  );
};
